<template>
<div>
    <label class="label-modal">Instituição</label>
    <v-autocomplete :items="instituicoes" :color="$primary" :multiple="Multiple" :disabled="$_ISDISABLED(Disabled, getSession.user.id_tipo_utilizador)" v-model="MyObject.instituicoes" :rules="RULES" item-text="nome" item-value="id_instituicao"></v-autocomplete>
</div>
</template>
<script>
import CRUD from '@/mixins/_CRUD'
export default {
    mixins: [CRUD],
    props: {
        MyObject: Object,
        RULES: Array,
        All: Boolean,
        Disabled: Array,
        Multiple: Boolean
    },
    data: () => ({
    }),
    computed: {
        instituicoes() {
            return this.$store.getters['instituicao/getAll'];
        },
        getSession() {
            return this.$store.getters['session/getState']
        },
    },
    methods: {
    },
}
</script>
